import { render, staticRenderFns } from "./admin-contract-2022-show.vue?vue&type=template&id=ba9e5cec&scoped=true"
import script from "./admin-contract-2022-show.vue?vue&type=script&lang=js"
export * from "./admin-contract-2022-show.vue?vue&type=script&lang=js"
import style0 from "./admin-contract-2022-show.vue?vue&type=style&index=0&id=ba9e5cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9e5cec",
  null
  
)

export default component.exports